import api from "..";


export const fetchAllVersions = (id, params = {}, callBack) => {
    api.get(`/history/sheets/${id}/versions/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const getSingleVersion = (sheetId, versionId, params = {}, callBack) => {
    api.get(`/history/sheets/${sheetId}/versions/${versionId}`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const rollbackVersion = (sheetId, versionId, params = {}, callBack) => {
    api.post(`/history/sheets/${sheetId}/versions/${versionId}/rollback/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const deleteVersion = (versionId, params = {}, callBack) => {
    api.delete(`/history/sheets/${versionId}/delete/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const shareSheetAccess = (sheetId, data, callBack) => {
    api.post(`/sheets/${sheetId}/invite/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const getUsersWithAccess = (sheetId, params = {}, callBack) => {
    api.get(`/sheets/${sheetId}/sheet-viewers/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const revokeSingleUser = (sheetId, id, callBack) => {
    api.delete(`/sheets/${sheetId}/revoke-access/${id}/`)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};


export const lockSheet = (sheetId, data, callBack) => {
    api.patch(`/sheets/${sheetId}/lock/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const acceptSheetInvitation = (token, callBack) => {
    api.post(`/sheets-invitations/${token}/accept/`, {})
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const getAiParsingData = (formData, callBack) => {
    api.post(`/ai-parsing/`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const bulkDeleteSheets = (data, callBack) => {
    api.delete(`/sheets/bulk-delete/`, { data })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};










